var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.faq'] = (function () {
    'use strict';

    const initialize = (block) => {
        const accordion = block.querySelector(".accordion");
        if (!accordion || !accordion.id) return;

        const button = block.querySelector(`button[aria-controls='${accordion.id}']`);
        if (!button) return;

        button.addEventListener("click", () => {
            toggleFaqPanels(accordion, button);
        });
    };

    const toggleFaqPanels = (accordion, button) => {
        const isPanelExpanded = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", isPanelExpanded ? "false" : "true");
        button.innerText = isPanelExpanded ? "View More" : "View Less";

        if (!isPanelExpanded) {
            const hiddenPanel = accordion.querySelectorAll(".accordion-item.d-none");
            hiddenPanel.forEach(panel => {
                panel.classList.add("accordion-item-conditional");
                panel.classList.remove("d-none");
            });
        }
        else {
            const conditionalPanel = accordion.querySelectorAll(".accordion-item.accordion-item-conditional");
            conditionalPanel.forEach(panel => {
                panel.classList.remove("accordion-item-conditional");
                panel.classList.add("d-none");
            });
        }
    };

    return {
        initialize
    };

})();